import { Component } from '@angular/core';
import {  NavController, NavParams, AlertController, ModalController, Events, LoadingController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
// import { OneSignal } from '@ionic-native/onesignal';
import { Geolocation } from '@ionic-native/geolocation';
import { TabsPage } from '../tabs/tabs';
import { Tabs2Page } from '../tabs2/tabs2';
import { ResumenPage } from '../resumen/resumen';
/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  form: any = {
    login:'',
    password:'',
  }
  mostrar= true
  modl: any
  loadModal: any
  super:any = false 
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http: HttpProvider,
    public alrtCtrl : AlertController,
    public loadingCtrl: LoadingController,
    public modal : ModalController,
    private geolocation: Geolocation,
    public events : Events,
    // public oneSignal : OneSignal
    ) {
      this.http.get('tasas').subscribe(
        (res:any) => {
          window.localStorage.cambio = JSON.stringify(res[0].tasa_v)
        },
        err => {
          console.log(err)
        }
      )
    }


  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  focus() {
    this.mostrar = false
  }

  nofocus() {
    this.mostrar = true
  }

  login(){
    if(this.form.login.length > 1 && this.form.password.length > 1){
      this.ActivarLoading()
      this.form.login =  this.form.login.replace(/ /g,'').toLowerCase()
      this.http.post(JSON.parse(this.super) === true ? 'usuario/login' : 'vendedor/login',this.form).subscribe(
        (res:any)=>{
          this.DesactivarLoading()
          if(res.status === 'denied'){
            this.alrtCtrl.create({
              title: 'Atención',
              subTitle: res.message,
              buttons:['Aceptar'],
            }).present()
          }else{
            // this.oneSignal.sendTags({"cliente": res.id})
            window.localStorage.setItem('id',res.id)
            window.localStorage.setItem('moneda','USD')
            window.localStorage.setItem('token',res.token)
            window.localStorage.setItem('login', this.form.login)
            if(this.super && !res.user.co_ven){
              window.localStorage.setItem('super',this.super.toString())
              window.localStorage.setItem('nombre','Supervisor')
              window.localStorage.setItem('vendedores', JSON.stringify(res.user.vendedores))
            }else{
              window.localStorage.setItem('nombre',res.user.ven_des)
              window.localStorage.setItem('co_ven',res.user.co_ven)
              window.localStorage.setItem('cajaAsignada',res.user.campo7)
              window.localStorage.setItem('co_zon',res.user.co_zon)
              let options = {
                enableHighAccuracy: true
              }
              this.geolocation.getCurrentPosition(options).then((resp) => {
                let info = {
                  co_ven: window.localStorage.getItem('co_ven'),
                  coordenadas: {
                    lat: resp.coords.latitude,
                    lng: resp.coords.longitude
                  }
                }
                this.http.post('ubicacion', info).subscribe((res:any)=> {
                  console.log(res)
                })
              })
            }
            this.events.publish('user:login')
            window.localStorage.setItem('showMenuResumen', "NO")
            this.navCtrl.setRoot(ResumenPage)
            // if (this.super) {
            //   this.navCtrl.setRoot(TabsPage)
            // } else {
            //   this.navCtrl.setRoot(Tabs2Page)
            // }
          }
        },
        error=>{
          this.DesactivarLoading()
          console.log(error)
          this.alrtCtrl.create({
            title: 'Atención',
            subTitle: "Error de conexión, por favor intente nuevamente o llame al administrador.",
            buttons:['Aceptar'],
          }).present()
        }
      )
    } 
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts